(ns ui.state.session.entity-utils)

(defn eid
  [entity-or-id]
  (or (:db/id entity-or-id)
      entity-or-id))
